import * as React from "react";

import {Checkbox} from "../../common/design2/checkbox/checkbox";

import {mlContentColumns} from "./ml-content-columns";

export const Columns = (
    {
        usableMailingLists,
        isSelected,
        filteredRecords,
        mailingListIds,
        showHeaderSummary,
        showSource,
    }
) => [
    {
        width: "1%",
        className: "checkbox",
        render: () => Checkbox({
            ...(
                !filteredRecords?.find(isSelected) ? {
                    checked: false,
                    onClick: () => mailingListIds.change((ids) => [
                        ...ids?.filter((id) => !filteredRecords.find((ml) => ml.id == id)) ?? [],
                        ...filteredRecords?.map((ml) => ml.id) ?? [],
                    ]),
                } : filteredRecords.find((ml) => !isSelected(ml)) ? {
                    checked: "midway",
                    onClick: () => mailingListIds.change((ids) => ids?.filter((id) => !filteredRecords.find((ml) => ml.id == id))),
                } : {
                    checked: true,
                    onClick: () => mailingListIds.change((ids) => ids?.filter((id) => !filteredRecords.find((ml) => ml.id == id))),
                }
            ),
            xdQaName: "Master Checkbox",
        }),
    },

    ...mlContentColumns({
        showSource,
        ...showHeaderSummary && usableMailingLists && {
            subTitle: `(${usableMailingLists.filter(isSelected).length} of ${usableMailingLists.length} mailing lists selected)`,
        },
    })
].filter(v=>v);

